export const slot = [
  {
    path: '/slot/test',
    name: 'SlotText',
    meta: {title: '测试插槽的使用'},
    component: () => import('../views/Slot/Index.vue')
  }
]
